import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './ControlBtn.module.scss';

const ControlBtn = ({
  onClick,
  content,
  inlineStyle,
  className,
  active,
  ...props
}) => {
  const handleClick = (e) => {
    e.preventDefault();

    if (typeof onClick === 'function') {
      onClick(inlineStyle);
    }
  };

  return (
    <Button
      {...props}
      onMouseDown={handleClick}
      className={cn(styles.root, className, {
        [styles.active]: active,
      })}
    >
      {content}
    </Button>
  );
};

export default ControlBtn;